export default __webpack_public_path__ + "static/media/avatar-default.701be91a.png";